var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotSatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83335 8.79815C8.30001 9.76482 7.70001 10.9982 6.53335 11.5648C5.36668 12.0982 4.03335 11.7648 3.56668 10.7982C3.30001 10.1648 7.56668 8.16482 7.83335 8.79815ZM12.1667 8.79815C11.7 9.76482 12.3 10.9982 13.4667 11.5648C14.6333 12.0982 15.9667 11.7648 16.4333 10.7982C16.7 10.1648 12.4333 8.16482 12.1667 8.79815Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90004 5.9333C6.00004 7.0333 3.83338 8.0333 2.40004 8.0333C2.20004 8.0333 2.16671 8.76664 2.40004 8.76664C4.03338 8.76664 6.40004 7.66664 7.46671 6.39997C7.63338 6.2333 7.03338 5.79997 6.90004 5.9333ZM13.1 5.9333C14 7.0333 16.1667 8.0333 17.6 8.0333C17.8 8.0333 17.8334 8.76664 17.6 8.76664C15.9667 8.76664 13.6 7.66664 12.5334 6.39997C12.3667 6.2333 12.9667 5.79997 13.1 5.9333Z",
    fill: "#917524"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8671 14.8008C11.0671 13.9674 8.93376 13.9674 7.13375 14.8008C6.70042 15.0008 7.23376 16.2008 7.70042 15.9674C8.90042 15.4008 10.6671 15.2008 12.3338 15.9674C12.7671 16.1674 13.3338 15.0341 12.8671 14.8008Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSatisfied);
export default __webpack_public_path__ + "static/media/NotSatisfied.a9efca1df3bacdb0d8fe5715c93ebd86.svg";
export { ForwardRef as ReactComponent };